export default __webpack_public_path__ + "static/media/iphone-02.334e435a.png";